import DOMPurify from 'dompurify';
import Button from './common/Button';

function TextBox(obj) {
    let title = obj.title,
        text = obj.text,
        button_color = obj.button?.color ? obj.button.color : 'orange',
        button_text = obj.button?.text ? obj.button.text : false,
        button_url = obj.button?.url ? obj.button.url : false,
        style = {},
        innerStyle = {},
        containerClasses = ' tw-max-w-screen-lg  tw-m-auto ',
        maxScreenClass = containerClasses+" tw-bg-teal tw-rounded-2xl ",
        maxScreenInnerClass = '';
        if(obj.fullBackground !== '') {
            style.backgroundColor = obj.fullBackground;
            maxScreenClass = '';
        }
        if(obj.backgroundColor !== '') {
            innerStyle.backgroundColor = obj.backgroundColor;
            maxScreenInnerClass = containerClasses;
            maxScreenClass = '';
        }
        
        
    return(
            <div className={"tw-mb-10 lg:tw-mb-3 tw-p-5 md:tw-p-0 "+maxScreenClass} style={style}>
              <div className={"tw-px-6 tw-py-6 tw-rounded-2xl md:tw-py-12 "+maxScreenInnerClass} style={innerStyle}>
                <div className={"tw-"+obj.textcolor+" tw-text-center"}>
                    <h2 className="tw-tracking-tight tw-font-italic tw-text-3xl tw-uppercase xmd:tw-leading-3 tw-mt-2 xmd:tw-leading-3 tw-mb-8">
                      {title}
                    </h2>
                    <p className="tw-mb-6 mb-description" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}/>
                    {(button_text && button_url) && (<div className="tw-text-center">
                      <Button
                        className="tw-mt-0 active:tw-border-transparent"
                        color={button_color}
                        size="small"
                        title={button_text}
                        href={button_url}
                      />
                    </div>)}
                </div>
              </div>
            </div>
    );
}


export default TextBox;